import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';
import { map } from 'rxjs';

@Component({
  selector: 'app-meeting-ended',
  imports: [TranslatePipe, NovaIcon],
  templateUrl: './meeting-ended.component.html',
  styleUrl: './meeting-ended.component.scss',
})
export class MeetingEnded {
  private readonly route = inject(ActivatedRoute);
  private readonly reason = toSignal(
    this.route.queryParamMap.pipe(map((p) => p.get('reason') ?? 'ended'))
  );

  private static readonly TITLE_KEYS: Record<string, string> = {
    left: 'meeting-ended.LEFT_TITLE',
    denied: 'meeting-ended.DENIED_TITLE',
  };

  private static readonly MESSAGE_KEYS: Record<string, string> = {
    left: 'meeting-ended.LEFT_MESSAGE',
    denied: 'meeting-ended.DENIED_MESSAGE',
  };

  protected readonly titleKey = computed(() =>
    MeetingEnded.TITLE_KEYS[this.reason() ?? 'ended'] ?? 'meeting-ended.TITLE'
  );

  protected readonly messageKey = computed(() =>
    MeetingEnded.MESSAGE_KEYS[this.reason() ?? 'ended'] ?? 'meeting-ended.MESSAGE'
  );
}
